var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"id":"card","flat":""}},[_c('v-card-title',[_c('v-icon',{attrs:{"left":""},domProps:{"textContent":_vm._s('mdi-cog-outline')}}),_vm._v(" "+_vm._s(_vm.$t("SETTINGS.TITLE"))+" ")],1),_c('v-card-text',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('app-language')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }